/**
 * @selector [data-js-feedback]
 * @enabled true
 */
import BaseModule from '../../modules/BaseModule.js';

export default class FeedbackButton extends BaseModule {
    init(element) {
        this.el = element;
        this.$el = $(element);

        this.$buttons = this.$el.find('[data-js-feedback-btn]');
        this.$thankYouContent = this.$el.find('[data-js-feedback-thankyou]');
        this.id = this.$el.attr('id');

        this.checkState();

        this.on('click', '[data-js-feedback-btn]', this.onFeedbackClick);

        return this;
    }

    checkState() {
        let localStorageItem = window.localStorage.getItem('jsFeedback');
        if (localStorageItem && JSON.parse(localStorageItem)[this.id]) {
            this.$thankYouContent.show();
            this.$el.addClass('has-feedback');
        }
    }

    onFeedbackClick(e) {
        e.preventDefault();

        const $link = $(e.target).closest('[data-js-feedback-btn]');
        this.$thankYouContent.addClass('show');
        this.$el.addClass('has-feedback');

        window.localStorage.setItem(
            'jsFeedback',
            JSON.stringify({
                ...(JSON.parse(window.localStorage.getItem('jsFeedback')) || {}),
                [this.id]: true,
            }),
        );

        if ($link.attr('href') && $link.attr('href').length) {
            // for potential BE logic
            $.ajax($link.attr('href'));
        }
    }
}
